import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9be1a716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = { class: "nav-initials-container" }
const _hoisted_3 = { class: "nav-initials" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatarimg" }, null, -1))
const _hoisted_5 = { class: "flex justify-between grow align-center" }
const _hoisted_6 = { class: "flex col g0" }
const _hoisted_7 = { class: "f10" }
const _hoisted_8 = { class: "flex align-center justify-center" }
const _hoisted_9 = {
  id: "navContainer",
  class: "nav-content"
}
const _hoisted_10 = { class: "flex col g12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/home.svg"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/distributors.svg"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/databases.svg"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/store2.svg"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/communication.svg"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/folder.svg"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/task_nav.svg"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/history.svg"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/auditing.svg"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/stores.svg"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/training.svg"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/probe.svg"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/accounts.svg"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/billing.svg"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img",
  src: "/ico/support.svg"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"margin-left":"80px"},
  class: "indicator"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "branding" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100%"},
    src: "/ico/label.svg"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_HalfCircleSpinner = _resolveComponent("HalfCircleSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userData?.name[0]), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUserAccount && _ctx.openUserAccount(...args))),
            class: "nav-header-name bold"
          }, _toDisplayString(_ctx.userData?.name) + " " + _toDisplayString(_ctx.userData?.surname), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Lang.getI18N(_ctx.userData?.role!)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.disconnect)
            ? (_openBlock(), _createBlock(_component_SeFadeButton, {
                key: 0,
                onClick: _ctx.logout,
                icon: "/ico/logout.svg"
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_HalfCircleSpinner, {
                key: 1,
                color: "#454eff",
                style: {"color":"#454eff","width":"30px","height":"30px"}
              }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('home', $event))),
          class: "nav-card selected"
        }, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("home")), 1)
        ]),
        (_ctx.userData?.role == _ctx.Role.Admin || _ctx.userData.role == _ctx.Role.Distributor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('distributors', $event))),
              class: "nav-card"
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("distributors")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.role != _ctx.Role.Customer)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('databases', $event))),
              class: "nav-card"
            }, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("databases")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.role == _ctx.Role.Distributor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('shop', $event))),
              class: "nav-card"
            }, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("shop")), 1)
            ]))
          : _createCommentVNode("", true),
        (
        _ctx.userData?.role == _ctx.Role.Admin ||
        _ctx.userData?.role == _ctx.Role.Customer ||
        _ctx.userData.role == _ctx.Role.Manager
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('communications', $event))),
              class: "nav-card"
            }, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("communication")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('documents', $event))),
          class: "nav-card"
        }, [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("documents")), 1)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('tasks', $event))),
              class: "nav-card"
            }, [
              _hoisted_17,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("tasks")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigate('history', $event))),
          class: "nav-card"
        }, [
          _hoisted_18,
          _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("history")), 1)
        ]),
        (
        _ctx.userData?.role == _ctx.Role.Distributor ||
        _ctx.userData?.role == _ctx.Role.Admin ||
        _ctx.userData?.role == _ctx.Role.Manager
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigate('auditing', $event))),
              class: "nav-card"
            }, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("auditing")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navigate('stores', $event))),
          class: "nav-card"
        }, [
          _hoisted_20,
          _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("stores")), 1)
        ]),
        _createElementVNode("div", {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigate('trainings', $event))),
          class: "nav-card"
        }, [
          _hoisted_21,
          _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("training")), 1)
        ]),
        (_ctx.userData?.role == _ctx.Role.Admin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 6,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigate('probes', $event))),
              class: "nav-card"
            }, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("probes")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.role == _ctx.Role.Distributor || _ctx.userData?.role == _ctx.Role.Admin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 7,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigate('accounts', $event))),
              class: "nav-card"
            }, [
              _hoisted_23,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("accounts")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.role == _ctx.Role.Admin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 8,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navigate('billing', $event))),
              class: "nav-card"
            }, [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("billing")), 1)
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", {
              key: 9,
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navigate('support', $event))),
              class: "nav-card"
            }, [
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_ctx.Lang.getI18N("support")) + " ", 1),
              _hoisted_26
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_27
    ])
  ], 64))
}